import { render } from "./ThePriceCompetitorHistoryPrices.vue?vue&type=template&id=971aba48"
import script from "./ThePriceCompetitorHistoryPrices.vue?vue&type=script&lang=js"
export * from "./ThePriceCompetitorHistoryPrices.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__